/**
 * @generated SignedSource<<81912b0132090ca15a86045beb29d7c0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MasqButton_User$data = {
  readonly " $fragmentSpreads": FragmentRefs<"masq_masqAsUser">;
  readonly " $fragmentType": "MasqButton_User";
};
export type MasqButton_User$key = {
  readonly " $data"?: MasqButton_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"MasqButton_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MasqButton_User",
  "selections": [
    {
      "kind": "InlineDataFragmentSpread",
      "name": "masq_masqAsUser",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "062b24b0f3fc371428f68499adc4a0c9";

export default node;
